// src/api/axios.js
import axios from 'axios';
import { API_BASE_URL, API_TIMEOUT, DEBUG_API } from './api';

// Stwórz instancję axios z konfiguracją
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
});

// Request Interceptor - automatycznie dodaje token i obsługuje FormData
api.interceptors.request.use(
  (config) => {
    // Pobierz token z localStorage
    const userInfo = localStorage.getItem('userInfo');
    
    if (userInfo) {
      try {
        const { token } = JSON.parse(userInfo);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('❌ Błąd parsowania userInfo:', error);
      }
    }
    
    // Nie ustawiaj Content-Type dla FormData - axios obsługuje to automatycznie
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      // Dla zwykłych requestów, ustaw JSON
      config.headers['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - obsługa błędów
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Obsługa błędów
    if (error.response) {
      // Server odpowiedział z błędem (4xx, 5xx)
      if (DEBUG_API) {
        console.error(`❌ Error ${error.config.url}:`, error.response.status, error.response.data);
      }

      // Token wygasł - wyloguj użytkownika
      if (error.response.status === 401) {
        localStorage.removeItem('userInfo');
        
        // Redirect do logowania (tylko jeśli nie jesteśmy już na stronie logowania)
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    } else if (error.request) {
      // Request wysłany, ale brak odpowiedzi
      console.error('❌ Brak odpowiedzi z serwera:', error.request);
    } else {
      // Błąd w konfiguracji requestu
      console.error('❌ Błąd requestu:', error.message);
    }

    return Promise.reject(error);
  }
);

export default api;

// Eksport również URL dla innych celów
export { API_BASE_URL };